(function () {
function $8713978b2328d32b$export$71511d61b312f219(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}


function $4fc75ccb937ab1df$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function $4fc75ccb937ab1df$export$71511d61b312f219(Constructor, protoProps, staticProps) {
    if (protoProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $4fc75ccb937ab1df$var$_defineProperties(Constructor, staticProps);
    return Constructor;
}


function $09cbfe85151ea6c6$export$71511d61b312f219(arr) {
    if (Array.isArray(arr)) return arr;
}


function $8ca2848f896a6803$export$71511d61b312f219(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}


function $a0bc1859061deae1$export$71511d61b312f219() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}


function $c3b10a83b523f372$export$71511d61b312f219(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}


function $d4f69c5c6c4654b1$export$71511d61b312f219(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return (0, $c3b10a83b523f372$export$71511d61b312f219)(o, minLen);
}


function $efec029548ccee7f$export$71511d61b312f219(arr, i) {
    return (0, $09cbfe85151ea6c6$export$71511d61b312f219)(arr) || (0, $8ca2848f896a6803$export$71511d61b312f219)(arr, i) || (0, $d4f69c5c6c4654b1$export$71511d61b312f219)(arr, i) || (0, $a0bc1859061deae1$export$71511d61b312f219)();
}


'use strict';
var $3d28d7f1aac198f5$var$Game = /*#__PURE__*/ function() {
    function Game(initialState) {
        (0, $8713978b2328d32b$export$71511d61b312f219)(this, Game);
        // eslint-disable-next-line no-console
        this.status = 'idle';
        this.score = 0;
        this.board = initialState || Array(4).fill(null).map(function() {
            return Array(4).fill(0);
        });
    }
    (0, $4fc75ccb937ab1df$export$71511d61b312f219)(Game, [
        {
            key: "moveLeft",
            value: function moveLeft() {
                var _this = this;
                var boardBefore = JSON.stringify(this.board);
                this.board = this.board.map(function(row) {
                    return _this.mergeRow(row);
                });
                if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
                this.checkStatus();
            }
        },
        {
            key: "moveRight",
            value: function moveRight() {
                var _this = this;
                var boardBefore = JSON.stringify(this.board);
                this.board = this.board.map(function(row) {
                    return _this.mergeRow(row.reverse()).reverse();
                });
                if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
                this.checkStatus();
            }
        },
        {
            key: "moveUp",
            value: function moveUp() {
                var _this = this;
                var boardBefore = JSON.stringify(this.board);
                this.board = this.transpose().map(function(row) {
                    return _this.mergeRow(row);
                });
                this.board = this.transpose();
                if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
                this.checkStatus();
            }
        },
        {
            key: "moveDown",
            value: function moveDown() {
                var _this = this;
                var boardBefore = JSON.stringify(this.board);
                this.board = this.transpose().map(function(row) {
                    return _this.mergeRow(row.reverse()).reverse();
                });
                this.board = this.transpose();
                if (boardBefore !== JSON.stringify(this.board)) this.addRandomTile();
                this.checkStatus();
            }
        },
        {
            key: "getScore",
            value: function getScore() {
                return this.score;
            }
        },
        {
            key: "getState",
            value: function getState() {
                return this.board;
            }
        },
        {
            key: "getStatus",
            value: function getStatus() {
                return this.status;
            }
        },
        {
            key: "start",
            value: function start() {
                this.status = 'playing';
                this.addRandomTile();
                this.addRandomTile();
            }
        },
        {
            key: "restart",
            value: function restart() {
                this.board = Array(4).fill(null).map(function() {
                    return Array(4).fill(0);
                });
                this.status = 'idle';
                this.score = 0;
            }
        },
        {
            key: "addRandomTile",
            value: function addRandomTile() {
                var emptyCells = [];
                for(var row = 0; row < this.board.length; row++){
                    for(var col = 0; col < this.board[row].length; col++)if (this.board[row][col] === 0) emptyCells.push([
                        row,
                        col
                    ]);
                }
                if (emptyCells.length === 0) return;
                var randomTile = Math.floor(Math.random() * emptyCells.length);
                var _emptyCells_randomTile = (0, $efec029548ccee7f$export$71511d61b312f219)(emptyCells[randomTile], 2), randomRow = _emptyCells_randomTile[0], randomCol = _emptyCells_randomTile[1];
                this.board[randomRow][randomCol] = Math.random() < 0.1 ? 4 : 2;
            }
        },
        {
            key: "mergeRow",
            value: function mergeRow(row) {
                var filtered = row.filter(function(cell) {
                    return cell !== 0;
                });
                for(var i = 0; i < filtered.length; i++)if (filtered[i] === filtered[i + 1]) {
                    filtered[i] *= 2;
                    filtered.splice(i + 1, 1);
                    this.score += filtered[i];
                }
                while(filtered.length < 4)filtered.push(0);
                return filtered;
            }
        },
        {
            key: "transpose",
            value: function transpose() {
                var _this = this;
                return this.board[0].map(function(_, colIndex) {
                    return _this.board.map(function(row) {
                        return row[colIndex];
                    });
                });
            }
        },
        {
            key: "hasNoMoves",
            value: function hasNoMoves() {
                for(var row = 0; row < this.board.length; row++)for(var col = 0; col < this.board[row].length; col++){
                    if (row + 1 < this.board.length && this.board[row][col] === this.board[row + 1][col]) return false;
                    if (this.board[row][col] === 0) return false;
                    if (col + 1 < this.board[row].length && this.board[row][col] === this.board[row][col + 1]) return false;
                }
                return true;
            }
        },
        {
            key: "checkStatus",
            value: function checkStatus() {
                if (this.board.flat().some(function(cell) {
                    return cell === 2048;
                })) this.status = 'win';
                else if (this.hasNoMoves()) this.status = 'lose';
            }
        }
    ]);
    return Game;
}();
var $3d28d7f1aac198f5$export$2e2bcd8739ae039 = $3d28d7f1aac198f5$var$Game;


'use strict';
var $197cd56b15c33885$var$game = new (0, $3d28d7f1aac198f5$export$2e2bcd8739ae039)();
function $197cd56b15c33885$var$renderBoard() {
    var cells = document.querySelectorAll('.field-cell');
    $197cd56b15c33885$var$game.getState().flat().map(function(value, index) {
        cells[index].className = 'field-cell';
        if (value > 0) cells[index].classList.add("field-cell--".concat(value));
        cells[index].textContent = value || '';
        if (value === 2048) document.querySelector('.message.message-win').classList.remove('hidden');
        if ($197cd56b15c33885$var$game.hasNoMoves()) document.querySelector('.message.message-lose').classList.remove('hidden');
    });
    $197cd56b15c33885$var$renderScore();
}
var $197cd56b15c33885$var$button = document.querySelector('.button.start');
$197cd56b15c33885$var$button.addEventListener('click', function() {
    if ($197cd56b15c33885$var$game.getStatus() === 'idle') {
        $197cd56b15c33885$var$game.start();
        $197cd56b15c33885$var$renderBoard();
        document.querySelector('.message.message-start').classList.add('hidden');
        $197cd56b15c33885$var$button.classList.remove('start');
        $197cd56b15c33885$var$button.textContent = 'Restart';
        $197cd56b15c33885$var$button.classList.add('restart');
    } else {
        $197cd56b15c33885$var$game.restart();
        $197cd56b15c33885$var$renderBoard();
        document.querySelector('.message.message-start').classList.remove('hidden');
        document.querySelector('.message.message-win').classList.add('hidden');
        document.querySelector('.message.message-lose').classList.add('hidden');
        $197cd56b15c33885$var$button.classList.remove('restart');
        $197cd56b15c33885$var$button.classList.add('start');
        $197cd56b15c33885$var$button.textContent = 'Start';
    }
});
document.addEventListener('keydown', function(e) {
    if ($197cd56b15c33885$var$game.getStatus() !== 'playing') return;
    switch(e.key){
        case 'ArrowLeft':
            $197cd56b15c33885$var$game.moveLeft();
            break;
        case 'ArrowRight':
            $197cd56b15c33885$var$game.moveRight();
            break;
        case 'ArrowDown':
            $197cd56b15c33885$var$game.moveDown();
            break;
        case 'ArrowUp':
            $197cd56b15c33885$var$game.moveUp();
            break;
    }
    $197cd56b15c33885$var$renderBoard();
});
function $197cd56b15c33885$var$renderScore() {
    document.querySelector('.game-score').textContent = $197cd56b15c33885$var$game.getScore();
}

})();
//# sourceMappingURL=js_2048_game.0a4e908e.js.map
